import request from "utils/request";

export async function addAccount(payload) {
	return request("/rest/cloud_accounts", {
		method: "PUT",
		body: payload
	});
}

export async function saveAccount(payload) {
	return request("/rest/cloud_accounts", {
		method: "POST",
		body: payload
	});
}

export async function deleteAccount(id) {
	return request("/rest/cloud_account/" + id, {
		method: "DELETE"
	});
}


export async function getCloudAccounts() {
    return request("/rest/cloud_accounts");
    // return {
    //     accounts: [
    //         {
    //             id: 1,
    //             friendlyName: "doan.chuvan@gmail.com",
    //             service: "AWS",
    //             info: `{ "accessKey": "access", "secretKey": "key" }`,
    //         },
    //         {
    //             id: 2,
    //             friendlyName: "doan.chuvan@gmail.com",
    //             service: "Google",
    //             info: `{ "credentials": "This is JSON credentials" }`,
    //         },
    //         {
    //             id: 3,
    //             friendlyName: "nirvanasinfo@gmail.com",
    //             service: "Azure",
    //             info: `{ "connectionString": "This is Connection String" }`,
    //         },
    //         {
    //             id: 4,
    //             friendlyName: "doan.chuvan@gmail.com",
    //             service: "AWS",
    //             info: `{ "accessKey": "access", "secretKey": "key" }`,
    //         },
    //         {
    //             id: 5,
    //             friendlyName: "doan.chuvan@gmail.com",
    //             service: "Google",
    //             info: `{ "credentials": "This is JSON credentials" }`,
    //         },
    //         {
    //             id: 6,
    //             friendlyName: "nirvanasinfo@gmail.com",
    //             service: "Azure",
    //             info: `{ "connectionString": "This is Connection String" }`,
    //         },
    //         {
    //             id: 7,
    //             friendlyName: "doan.chuvan@gmail.com",
    //             service: "AWS",
    //             info: `{ "accessKey": "access", "secretKey": "key" }`,
    //         },
    //         {
    //             id: 8,
    //             friendlyName: "doan.chuvan@gmail.com",
    //             service: "Google",
    //             info: `{ "credentials": "This is JSON credentials" }`,
    //         },
    //         {
    //             id: 9,
    //             friendlyName: "nirvanasinfo@gmail.com",
    //             service: "Azure",
    //             info: `{ "connectionString": "This is Connection String" }`,
    //         },
    //         {
    //             id: 10,
    //             friendlyName: "doan.chuvan@gmail.com",
    //             service: "AWS",
    //             info: `{ "accessKey": "access", "secretKey": "key" }`,
    //         },
    //         {
    //             id: 11,
    //             friendlyName: "doan.chuvan@gmail.com",
    //             service: "Google",
    //             info: `{ "credentials": "This is JSON credentials" }`,
    //         },
    //         {
    //             id: 12,
    //             friendlyName: "nirvanasinfo@gmail.com",
    //             service: "Azure",
    //             info: `{ "connectionString": "This is Connection String" }`,
    //         },
    //         {
    //             id: 13,
    //             friendlyName: "doan.chuvan@gmail.com",
    //             service: "AWS",
    //             info: `{ "accessKey": "access", "secretKey": "key" }`,
    //         },
    //         {
    //             id: 14,
    //             friendlyName: "doan.chuvan@gmail.com",
    //             service: "Google",
    //             info: `{ "credentials": "This is JSON credentials" }`,
    //         },
    //         {
    //             id: 15,
    //             friendlyName: "nirvanasinfo@gmail.com",
    //             service: "Azure",
    //             info: `{ "connectionString": "This is Connection String" }`,
    //         }
    //     ]
    // }
}
